import { memo } from 'react';
import { AccessoryDetailProps } from '../../models';

const AccessoryDetailFallback = ({ accessory }: AccessoryDetailProps) => (
  <div className="bot-accessories__detail-card">
    <div className="bot-accessories__detail-title">{accessory.name}</div>
    <p className="bot-accessories__detail-description">
      Additional configuration for this accessory type is coming soon.
    </p>
  </div>
);

export default memo(AccessoryDetailFallback);

